import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import activityIcon from 'src/public/img/activity.svg';
import startSmallIcon from 'src/public/img/startSmall.svg';
import timingIcon from 'src/public/img/timing.svg';

import { TipCard } from 'src/modules/programs/components/TipCard';
import * as S from 'src/modules/programs/stepComponents/styles';

const mindfulnessTipsAvatars = [timingIcon, activityIcon, startSmallIcon];

interface CardContent {
    title: string;
    content: string;
}

type Props = WithTranslation;

export const MindfulnessTipsWeekTwoStep = withTranslation('cp')(({ t }: Props) => {
    const tipCards: CardContent[] = t('week-2.mindfulness-tips.tipCards', { returnObjects: true });

    return (
        <>
            <S.ContentRow>
                <S.ContentColumn>
                    <S.StepHeading small>{t('week-2.mindfulness-tips.subheading')}</S.StepHeading>
                    <S.StepHeading>{t('week-2.mindfulness-tips.heading')}</S.StepHeading>
                    <S.StepDescription small>
                        {t('week-2.mindfulness-tips.description')}
                    </S.StepDescription>
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow type="flex">
                {tipCards.map((cardContent: CardContent, index: number) => (
                    <TipCard
                        key={cardContent.title}
                        title={cardContent.title}
                        iconUrl={mindfulnessTipsAvatars[index]}
                        children={
                            <S.StepDescription small>{cardContent.content}</S.StepDescription>
                        }
                    />
                ))}
            </S.ContentRow>
        </>
    );
});
